import { render, staticRenderFns } from "./ChatAuthorMediaMessage.vue?vue&type=template&id=1c1e23ae&scoped=true"
import script from "./ChatAuthorMediaMessage.vue?vue&type=script&lang=js"
export * from "./ChatAuthorMediaMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatAuthorMediaMessage.vue?vue&type=style&index=0&id=1c1e23ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1e23ae",
  null
  
)

export default component.exports